// @flow
import styled, { css } from "styled-components";
import { media } from "@nested/ui";
import SubMenu from "./SubMenu";

export const NavLinks = styled.ul`
  list-style-type: none;
  width: 100%;
  margin: 0px;
  padding: 18px 26px;

  /* 
   * The more section of the nav has slightly different
   * styling to others as it has a background on mobile 
   */
  ${({ more }) =>
    more &&
    css`
      background-color: #f8f8f8;
      ${SubMenu} {
        margin-bottom: 0px;
      }

      ${media.tablet`
      li {
        margin-right: 0px;
      }
      background-color: transparent;
    `};
    `};

  ${media.tablet`
    display: inline;
    margin: auto;
    padding: 0px;
    margin: 0px;
  `};
`;

export const NavLink = styled.li`
  letter-spacing: 1.5px;
  line-height: 1.93;
  letter-spacing: 1.8px;
  font-weight: ${({ theme }) => theme.typography.bold};
  font-size: 14px;
  margin-top: 10px;
  color: #353f52;
  text-transform: uppercase;
  position: relative;

  /*
   * The show prop is for displaying more items in the desktop nav when the viewport
   * is wider. They are always displayed on mobile, and then hidden until the specified
   * width on desktop. For example, a NavLink with show="lg" means it is shown until
   * md, when it is then hidden until lg and above
   */
  ${({ show }) =>
    show &&
    css`
      ${media.tablet`
        display: none !important;
      `} @media (min-width: ${show / 16}em) {
        display: inline-block !important;
      }
    `};

  svg {
    display: none;
  }

  ${({ heading }) =>
    heading &&
    css`
      margin-top: 0px;
      line-height: 2.25;
      letter-spacing: 1.5px;
      font-size: 12px;
      color: #8c8c8c;

      ${media.tablet`
      font-size: 14px;
      letter-spacing: 1.8px;
      color: #353f52;
    `};
    `};

  & > a {
    text-transform: inherit;
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    text-decoration: none;

    &:hover {
      padding-bottom: 5px;
      border-bottom: 2px solid #353f52;
    }
  }

  ${media.tablet`
    svg {
      display: inline-block;
      position: relative;
      top: -2px;
      margin-left: 6px;
    }
    display: inline-block;
    margin-right: 30px;
    
    margin-top: 0px;
    height: 100%;
    line-height: 110px;

    &:hover > ul {
      visibility: visible;
      opacity: 1;
      transform: translateX(-50%);
    }
  `};
`;
